// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-ktfZs";
var _4 = "block-nFkiv";
var _5 = "verticalLine-3Or05";
var _6 = "blockTitle-18_8Z";
var _7 = "headerBlock-3MhoG";
var _8 = "headerTop-22EJG";
var _9 = "requestIdWrapper-38N5I";
var _a = "statusWrapper-3VD3Y";
var _b = "requestId-1cB2I";
var _c = "createDate-1u1F_";
var _d = "timeLimit-2O2IP";
var _e = "breadcrumbs-1cfSC";
var _f = "breadcrumb-2sWHL";
var _10 = "mobileBreadcrumbs-1HRDM";
var _11 = "commentBlock-OrXF4";
var _12 = "comment-1SnWe";
var _13 = "filesBlock-2lR7j";
var _14 = "files-2U0HG";
var _15 = "file-3w2Wc";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "block", _5 as "verticalLine", _6 as "blockTitle", _7 as "headerBlock", _8 as "headerTop", _9 as "requestIdWrapper", _a as "statusWrapper", _b as "requestId", _c as "createDate", _d as "timeLimit", _e as "breadcrumbs", _f as "breadcrumb", _10 as "mobileBreadcrumbs", _11 as "commentBlock", _12 as "comment", _13 as "filesBlock", _14 as "files", _15 as "file" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "block": _4, "verticalLine": _5, "blockTitle": _6, "headerBlock": _7, "headerTop": _8, "requestIdWrapper": _9, "statusWrapper": _a, "requestId": _b, "createDate": _c, "timeLimit": _d, "breadcrumbs": _e, "breadcrumb": _f, "mobileBreadcrumbs": _10, "commentBlock": _11, "comment": _12, "filesBlock": _13, "files": _14, "file": _15 }
